import {
  OpalApiResponseDocument,
  type OpalApiRequestParams,
} from '@opallabs/api'
import { makeQueryHelper, type QueryHelperTypes } from '@opallabs/react-query'

export type QueryKeyParams =
  OpalApiRequestParams<'ReadCategoryTypesV3'>['query']['filter']

export type PlanTypesQueryHelperTypes = QueryHelperTypes<
  QueryKeyParams,
  OpalApiResponseDocument<'ReadCategoryTypesV3', 200>
>

export const planTypesQueryHelper = makeQueryHelper<
  QueryKeyParams,
  PlanTypesQueryHelperTypes['CacheData']
>(['plans', 'types'] as const)
